module.exports = __webpack_public_path__ + "static/media/cognito_settings_active.0c8dd516.svg";